/**
 * @generated SignedSource<<47a9e5037bb5b13f97d21da6cd3fb8f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgSpaceEditDeleteMutation$variables = {
  id: string;
};
export type OrgSpaceEditDeleteMutation$data = {
  readonly storecastSpace: {
    readonly delete: {
      readonly id: string;
    };
  } | null;
};
export type OrgSpaceEditDeleteMutation = {
  response: OrgSpaceEditDeleteMutation$data;
  variables: OrgSpaceEditDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "StorecastSpaceMutation",
    "kind": "LinkedField",
    "name": "storecastSpace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StorecastSpace",
        "kind": "LinkedField",
        "name": "delete",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgSpaceEditDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgSpaceEditDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6a64c75208b7708108687cf936cee767",
    "id": null,
    "metadata": {},
    "name": "OrgSpaceEditDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation OrgSpaceEditDeleteMutation(\n  $id: ID!\n) {\n  storecastSpace(id: $id) {\n    delete {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "48efdf21dad9abf86a4be981450f9cdd";

export default node;
